import { z } from 'zod'

export const updateMemberSharesSchema = z
  .object({
    shares: z.array(
      z.object({
        memberId: z.string().guid(),
        sharePercentage: z.number().min(0).max(100),
      })
    ),
  })
  .refine((d) => Math.abs(d.shares.reduce((s, x) => s + x.sharePercentage, 0) - 100) < 0.01, {
    message: 'Shares must sum to 100%',
  })

export type UpdateMemberSharesDto = z.infer<typeof updateMemberSharesSchema>
